import React, { useEffect, useState } from 'react';
import { connectToWebChat } from 'botframework-webchat';
import LiveChatCard from './live-chat-card/liveChatCard';
import useChatbot from '../../../Hooks/useChatbot';

const ConnectedAttachmentWithLiveChat = connectToWebChat(
  ({ postActivity }) => ({ postActivity })
)(
  props => {
    const [showForm, setShowForm] = useState(true);
    const { isLiveChatActive } = useChatbot();

    // When the bot actually starts the live chat, we want to hide the form.
    // useEffect(() => {
    //   if (isLiveChatActive) {
    //     setShowForm(false);
    //   }
    // }, [isLiveChatActive]);

    // useEffect(() => {
    //   if (!showForm) {
    //     const bubbles = document.querySelectorAll('.webchat__row.attachment');
    //     bubbles.forEach(bubble => {
    //       bubble.style.display = 'none';
    //     });
    //   }
    // }, [showForm]);
    
    if (!showForm) return null;
    return (
      <LiveChatCard
        {...props}
        onCancel={() => setShowForm(false)}
      />
    );
  }
);



export default ConnectedAttachmentWithLiveChat;
